import { Button } from "@/components/ui/button";
import { CameraIcon } from "lucide-react";
import { useTakePicture } from "@/hooks/useTakePicture";
import { useCallback } from "react";

interface FileInputProps {
  selectedFile: File | null;
  onFileSelect: (file: File | null) => void;
}

function convertBase64ToFile(base64String: string, format: string): File {
  const base64Data = base64String;
  const byteString = atob(base64Data);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  const blob = new Blob([uint8Array], { type: `image/${format}` });
  return new File([blob], `photo_${Date.now()}.${format}`, {
    type: `image/${format}`,
  });
}

export function FileInput({ onFileSelect }: FileInputProps) {
  const { takePicture } = useTakePicture();

  const handleButtonClick = useCallback(async () => {
    const photo = await takePicture();

    if (!photo || !photo.base64String) {
      return;
    }

    const file = convertBase64ToFile(
      photo.base64String,
      photo.format || "jpeg",
    );

    onFileSelect(file);
  }, [onFileSelect, takePicture]);

  return (
    <Button
      variant="outline"
      onClick={handleButtonClick}
      type="button"
      className="rounded-md"
    >
      <CameraIcon />
    </Button>
  );
}
